import { Shape } from "./shape.js";
export function metadata(...fullArgs) {
    if (typeof fullArgs[0] !== "string")
        return fullArgs.flat();
    const [name, factory, ...args] = fullArgs;
    return [
        factory
            ? {
                type: "factory",
                name,
                factory,
                args,
            }
            : {
                type: "atomic",
                name,
            },
    ];
}
export class ShapeVisitor {
    #fallback;
    #visitors = new Map();
    add(shape, fn) {
        if (shape instanceof Shape) {
            shape = shape.metadata[0];
            if (!shape)
                throw new Error("Cannot register visitor for metadata-less shape");
        }
        if (this.#visitors.has(shape)) {
            throw new Error("Duplicate visitor");
        }
        this.#visitors.set(shape, fn);
        return this;
    }
    fallback(fn) {
        if (this.#fallback) {
            throw new Error("Duplicate fallback");
        }
        this.#fallback = fn;
        return this;
    }
    /**
     * ```ts
     * visitor.generic(<T>() =>
     *   visitor.add($.array<T>, (shape, $el) => {
     *     ...
     *   })
     * )
     * ```
     */
    generic(fn) {
        fn(this);
        return this;
    }
    visit(shape) {
        for (const metadata of shape.metadata) {
            let visitor = this.#visitors.get(metadata);
            if (visitor)
                return visitor(shape);
            if (metadata.type !== "factory")
                continue;
            visitor = this.#visitors.get(metadata.factory);
            if (visitor)
                return visitor(shape, ...metadata.args);
        }
        if (this.#fallback) {
            return this.#fallback(shape);
        }
        throw new Error("Unrecognized shape");
    }
}
//# sourceMappingURL=metadata.js.map